<template>
	<RightPane
		v-bind:display="display"
		v-bind:persistent="is_showpicker"
		v-on:close="onClose"
	>
		<ModalVScrollable class="project-info"
			title="案件情報"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header v-if="isEditable">
				<div class="modal-header-project-info">
					<v-btn flat blue large color="white" v-on:click="onClickDone">完了</v-btn>
					<v-btn flat blue large color="white" v-on:click="deleteMe">削除</v-btn>
				</div>
			</template>
			<template v-if="value">
				<v-layout wrap mt-3 mb-3 mx-2 pr-2>
					<v-flex xs2 v-bind:class="classNameLabel" style="margin-top:-4px;" v-if="isEditable">
						名前
					</v-flex>
					<v-flex xs2 v-bind:class="classNameLabel" v-else>
						名前
					</v-flex>
					<v-flex xs10 class="content-name">
						<template v-if="isEditable">
							<v-text-field
								v-model=value.name
								maxlength="40"
								:rules="[rules.required, rules.name_length]"
								counter
							></v-text-field>
						</template>
						<template v-else>
							{{ value.name }}
						</template>
					</v-flex>
				</v-layout>
				<v-layout wrap mx-2 pr-2><!-- スケジュールリスト -->
					<RightPaneTaskScheduleList v-for="schedule in value.schedules" 
						:key="schedule.code" 
						v-bind:schedule="schedule"
						v-bind:isPositionLast="util.isPositionLast(value.schedules, schedule)"
						v-bind:deletable="value.schedules.length > 1"
						v-bind:isEditable="isEditable"
						v-on:on-change-picker-state="changePickerState"
						v-on:add-schedule="AddSchedule"
						v-on:delete-schedule="DeleteSchedule"
					/>
				</v-layout>	<!-- スケジュールリスト -->
				<v-layout wrap mx-2 mb-2 mt-3 pr-2>
					<v-flex xs2 d-flex align-start class="multi-line-label">
						分類
					</v-flex>
					<v-flex xs10 class="content">
						<Classes
							:items="value.classes"
							:max_width="isEditable ? 224: 264"
							:all_show=true
						/>
						<v-btn flat fab class="btn-add-class" v-if="isEditable">
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout wrap mx-2 pt-3 pr-2>
					<v-flex xs2 d-flex align-start class="multi-line-label">
						備考
					</v-flex>
					<v-flex xs10 class="content">
						<template v-if="isEditable">
							<v-textarea
								v-model=value.remarks
								outline
								maxlength="100"
								:rules="[rules.remarks_length]"
								counter
							></v-textarea>
						</template>
						<template v-else>
							{{ value.remarks }}
						</template>
					</v-flex>
				</v-layout>
			</template>
		</ModalVScrollable>
	</RightPane>
</template>
<script>


import RightPane from '../RightPane';
import ModalVScrollable from '../ModalVScrollable';
import RightPaneTaskScheduleList from '../RightPaneTaskScheduleList';
import Classes from '../Classes';
import Util from '../../classes/Util';
import Schedule from '../../classes/Schedule';

const validateLengthName = function(value) {
	if(value.length <= 40)
		return true;
	return false;
};

const validateLengthRemarks = function(value) {
	if(value.length <= 100)
		return true;
	return false;
};
export default {
	name: 'TCRightPaneProjectInfo',
	props: [
		'value',
	],
	components: {
		RightPane,
		ModalVScrollable,
		RightPaneTaskScheduleList,
		Classes,
	},
	data: function() {
		return {
			rules: {
				required: v => !!v || '入力してください',
				name_length: v => validateLengthName(v) || '40文字以内で入力してください',
				remarks_length: v => validateLengthRemarks(v) || '100文字以内で入力してください',
			},
			util: Util,
			is_showpicker : false,
		}
	},
	methods: {
		onClose: function() {
			this.$emit('close');
		},
		onClickDone: function(){
		},
		deleteMe: function(){
		},
		changePickerState:function(e){
			this.is_showpicker = e.isShow;
		},
		AddSchedule: function(){
			let s = this.createNewSchedule();
			this.value.schedules.push(s);
		},
		DeleteSchedule: function(schedule){
			if(schedule){
				Util.array_remove(this.value.schedules, schedule);
			}else{
				return;
			}
		},
		createNewSchedule: function() {
			return new Schedule.defaultSchedule({
				project_code: this.value.code,
				date: this.$store.getters.currentDate,
			})
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		isEditable: function() {
			return this.$store.getters['chart/isEditable'];
		},
		classNameLabel: function() {
			if(this.isEditable)
				return ['label'];
			else
				return ['multi-line-label'];
		},
	},
	watch: {
	},
}
</script>
<style>
	.modal-window.project-info .row-group {
		height: 60px;
	}
	.modal-window.project-info .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.modal-window.project-info .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
		padding-top: 1px;
	}
	.modal-window.project-info .content {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
	}
	.modal-window.project-info .content-name {
		word-wrap: break-word;
		font-size: 16px;
	}
	.modal-window.project-info .modal-header-project-info {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.project-info .btn-add-class {
		height: 24px;
		width: 24px;
		margin: 0px;
	}
</style>
